import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Card, Progress, Collapse, notification, Divider, Drawer, Alert, Typography, Space } from 'antd';
import {CloseRounded, DoneAllRounded, TaskAltRounded} from "@mui/icons-material";
import Stylebox from '../../../Components/Stylebox/Stylebox';
import {MongoQueryBuilder} from "../../../utils/mongoQuery";
import {fetchFilteredTickers} from "../../../Api/tickersApi";
import TickersTable from "../../../Components/TickersTable";
import NivoPieChart from "../../../charts/nivo/NivoPieChart";
import NivoBarChart from "../../../charts/nivo/NivoBarChart";
import NivoTreeChart from "../../../charts/nivo/NivoTreeChart";
import {stringMixin} from "../../../utils/strings";
import {getRandomColor} from "../../../utils/colorUtils";

const { Panel } = Collapse;

const calculateTotalWeight = (items) => {
    return items.reduce((acc, item) => acc + parseFloat(item.wgt || 0), 0);
};



const formatQueryOnStyleboxSelect = (selectedStyle) => {
    let mongoQuery = new MongoQueryBuilder();
    let [sizes, styles] = [[], []];
    let [size, style] = selectedStyle.split('_');
    if (!sizes.includes(size)) sizes.push(size);
    if (!styles.includes(style)) styles.push(style);
    mongoQuery.addCondition({fullPath: 'type', value: 'etf', operator: 'eq'})
    mongoQuery.inList('tags.style', styles)
    mongoQuery.inList('tags.size', sizes)
    mongoQuery.setLimit(20);
    mongoQuery.setSort({'metrics.mktcap': -1});
    mongoQuery.updateProjection(['name', 'symbol', 'logo', 'type'])
    return mongoQuery;
}


const BuilderPanel = ({ items, onTickerSubmit }) => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const tickersData = useSelector((state) => state.tickers.filteredTickers);
  const totalWeight = calculateTotalWeight(items);

  const handleStyleboxSelect = (selectedStyle) => {
    const mongoQuery = formatQueryOnStyleboxSelect(selectedStyle);
    dispatch(fetchFilteredTickers(mongoQuery.toMongoQuery()));
    setIsModalVisible(true);
    setModalTitle(`Select Tickers for ${stringMixin.fmt(selectedStyle)}`);
  }

  useEffect(() => {
    if (totalWeight > 101) {
      notification.error({
        message: 'Total Weight Exceeded',
        description: 'The total weight of all items exceeds 100%. Please adjust the weights accordingly.',
        duration: 0, // Duration set to 0 will make the notification stay until the user closes it manually.
      });
    }
  }, [totalWeight]);

  const handleTickerSubmit = (selectedTickers) => {
      console.log(selectedTickers)
    if (selectedTickers.length > 0) {
        onTickerSubmit(selectedTickers);
    }
    setIsModalVisible(false); // Close the modal
  };

  const barData = items.map(item => ({ id: item.name, [item.name]: item.wgt }));
  const pieData = items.map(item => ({ id: item.name, value: item.wgt }));
  const treeData = {name: "Portfolio", children: items.map(x=>{
      return {name: x.name, value: x?.wgt?.toFixed(1) ?? 0, color: getRandomColor()}
      })};

  return (
      <>
        <Card bordered={false} style={{margin: 'auto'}}>
            <Typography.Text style={{fontWeight: '600'}}>
                {totalWeight === 100 ? 'Portfolio Filled (100%)' : `Total Weight: ${totalWeight.toFixed(1)}%`}
            </Typography.Text>
              <Progress
                  className={'py-3'}
                percent={Math.min(100, totalWeight)} // Cap the progress at 100% to prevent overflow in the UI
                status={'normal'}
                strokeColor={{
                  '0%': totalWeight < 90 ? '#F66565' : '#B0ECD8',
                  '100%': totalWeight < 90 ? '#FC0E0E' : '#0CE89F',
                }}
                size={[300, 15]}
                percentPosition={{
                        align: 'center',
                        type: totalWeight < 20 ? 'outer' : 'inner'
                }}
                  format={()=>''}
              />
        </Card>
          <Divider style={{border: '1px solid #ededed'}}/>
          <Card bordered={false} className={'gapless'}>
              {items.length > 0 && totalWeight > 0 ?
                  <div style={{height: 300, width: '100%', border: 'none', margin: 'auto'}}>
                      {items.length < 15 ? (
                          <NivoTreeChart data={treeData} initialMode={'slice'} />
                      ) : <NivoPieChart data={pieData} radius={0.5} showLabels={false}/>}
                  </div> : <div className={'has-text-centered'}>No Allocations</div>
              }
        </Card>
          <Divider style={{border: '1px solid #ededed'}}/>

        <Card bordered={false} title={<Typography.Title level={4}>Stylebox Search</Typography.Title>}>
            <Stylebox onSubmit={handleStyleboxSelect}
                        imgUrl={'https://storage.googleapis.com/finiat-web-static-resources/adobe-more/dark-twist-dna-wave.jpeg'}  />
        </Card>
      <Drawer
          title={modalTitle}
          open={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          width={600}
          placement={'right'}
      >

          <Typography.Text>Select ETFs within this style to add them to your portfolio</Typography.Text>
          <Divider/>
          <TickersTable tickers={tickersData} onSubmit={handleTickerSubmit} submitText={'Add Selected Builder'} />
      </Drawer>
      </>
  );
};

export default BuilderPanel;
